import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { TextField } from '@johnlewispartnership/wtr-ingredients/dist/Forms';
import { Typography } from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/TextLink';
import { MYWAITROSE_FIELD } from '../../../../components/CompetitionsForms/constants';
import styles from '../../CompetitionsForm.module.scss';
const MyWaitroseDetails = ({ form }) => {
    var _a;
    return (React.createElement("div", { className: classNames(styles.spacerLarge, styles.sectionWrapper), "data-testid": "mywaitrose-section" },
        React.createElement(Typography, { styleAs: "paragraph", element: "p" }, "Enter the 16-digit Membership number shown on your myWaitrose card:"),
        React.createElement("div", { className: styles.myWaitroseImageWrapper },
            React.createElement("img", { className: styles.image, height: "153", width: "276", alt: "Where to find your myWaitrose Number", src: "https://waitrose-prod.scene7.com/is/image/waitroseprod/mywaitrose-comp-3?$Waitrose-Image-Preset-95$" })),
        React.createElement("div", { className: styles.spacer },
            React.createElement(Typography, { styleAs: "paragraph", element: "p" },
                "Your digital myWaitrose card be found by visiting",
                ' ',
                React.createElement(TextLink, { href: "/ecom/my-waitrose", underline: "always" },
                    React.createElement("b", null, "myWaitrose loyalty")))),
        React.createElement("div", { className: styles.spacerLarge },
            React.createElement(TextField, { errorText: (_a = form.errors.loyaltyCardNumber) === null || _a === void 0 ? void 0 : _a.message, id: "myWaitrose-card-number", label: "myWaitrose card number", name: "loyaltyCardNumber", ref: form.register(MYWAITROSE_FIELD) }))));
};
MyWaitroseDetails.propTypes = {
    form: propTypes.shape({
        errors: propTypes.shape({
            loyaltyCardNumber: propTypes.shape({ type: propTypes.string, message: propTypes.string }),
        }).isRequired,
        register: propTypes.func.isRequired,
    }).isRequired,
};
export default MyWaitroseDetails;
//# sourceMappingURL=index.js.map